import { render } from "./Sponsorship.vue?vue&type=template&id=1f5fc28a&scoped=true"
import script from "./Sponsorship.vue?vue&type=script&lang=js"
export * from "./Sponsorship.vue?vue&type=script&lang=js"

import "./Sponsorship.vue?vue&type=style&index=0&id=1f5fc28a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5fc28a"]])

export default __exports__